import { render, staticRenderFns } from "./component_rule_mobile.vue?vue&type=template&id=c6d050fc&scoped=true&"
import script from "./component_rule_mobile.vue?vue&type=script&lang=js&"
export * from "./component_rule_mobile.vue?vue&type=script&lang=js&"
import style0 from "./component_rule_mobile.vue?vue&type=style&index=0&id=c6d050fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d050fc",
  null
  
)

export default component.exports